<template>
    <div class="row">
        <div class="col-md-12 scroll-x">
            <table class="table">
                <tr class="table-header">
                    <th>&nbsp;</th>
                    <th>
                        <a href="#">descrizione</a>
                    </th>
                    <th>
                        <a href="#">valore soglia</a>
                    </th>
                    <th>
                        <a href="#">ultima esecuzione</a>
                    </th>
                </tr>
                <template v-if="rows.length > 0">
                    <tr v-for="(row, index) in rows" :key="index" class="tuple">
                        <td class="dual-icon">
                            <div v-if="row['status'] == 'Ok'" class="icon check-mark"></div>
                            <div v-else-if="row['status'] == 'Alarm'" class="icon alert-octagon"></div>
                            
                            <button v-if="row['enabled']" class="icon alarm-checked" data-toggle="modal" data-target="#editAlarm"></button>                        
                        </td>
                        <td v-html="row['description']"></td>
                        <td>
                            <span :class="row['status'] != 'Ok' ? 'threshold alert-th': 'threshold'" v-html="row['thresholdValue']"></span>
                        </td>
                        <td>
                            <div class="date" v-html="row['stringLastExecution'] == undefined ? (row['stringExecutedAt'] == undefined ? '' :  row['stringExecutedAt']) : row['stringLastExecution']"></div>
                        </td>
                    </tr>                
                </template>
                <template v-else>
                    <tr class="tuple">
                        <td class="text-center pad-20" colspan="4">{{ "noResults" | translate}}</td>
                    </tr>
                </template>
            </table>
        </div>
        
        <!-- <div class="col-md-12">
            <div class="paginator">
                <a class="left" href="#"></a>
                <a class="page current" href="#">1</a>
                <a class="page" href="#">2</a>
                <a class="page" href="#">3</a>
                <a class="right" href="#"></a>
            </div>
        </div> -->

        <overlay :enabled="loading"></overlay>
    </div>
</template>

<script>
    import moment from 'moment'
    import notificator from '../mixins/notificator';
    import { mapGetters } from 'vuex'
    
    import Overlay from '@/components/Overlay.vue';

    export default {
        props: ['settings', 'tab', 'getData'],

        components: {Overlay},   

        mixins: [notificator],

        data() {
            return {
                rows: [],
                loading: false,
                fields: {
                    parametersAttributes: {},
                    aggregationFrequencyAttributes: {},
                    aggregationModeAttributes: {},
                    lowerboundAttributes: {},
                    upperboundAttributes: {}
                },  
            }
        },

        created() {
            //Parameters
            this.fields.parametersAttributes = this.settings.parametersAttributes;
            this.fields.parametersAttributes['value']['value'] = this['selectedAlarmsParameters'];
            
            //Lowerbound
            this.fields.lowerboundAttributes = this.settings.lowerboundAttributes;
            this.fields.lowerboundAttributes['value']['value'] = this['selectedAlarmsLowerbound'];
            
            //Upperbound
            this.fields.upperboundAttributes = this.settings.upperboundAttributes;
            this.fields.upperboundAttributes['value']['value'] = this['selectedAlarmsUpperbound'];

            if(this.getData != null) {
                if(this.tab == 'stato-tab')
                    this.getClientAlarms();
                else if(this.tab == 'storico-tab')
                    this.getAlarmLog();                
            }
        },

        computed: {    
            ...mapGetters([
                'selectedAlarmsDevices',
                'selectedAlarmsParameters',
                'selectedAlarmsLowerbound',
                'selectedAlarmsUpperbound'                
            ])
        },

        watch: {
            getData() {
                if(this.getData != null) {
                    if(this.tab == 'stato-tab')
                        this.getClientAlarms();
                    else if(this.tab == 'storico-tab')
                        this.getAlarmLog();
                }
            },
        },

        methods: {
            generateDevicesQueries() {
                var offset = new Date().getTimezoneOffset();

                var request = {};

                if(this.selectedAlarmsDevices.device != undefined)
                    request['deviceIds'] = [this.selectedAlarmsDevices.device['id']];

                if(this.selectedAlarmsParameters != undefined)
                    request['checkId'] = this.selectedAlarmsParameters;

                if(this.tab == 'storico-tab') {
                    if(this.fields.lowerboundAttributes != undefined && this['selectedAlarmsLowerbound'] != undefined) {
                        if(this.fields.lowerboundAttributes.dateFormat.value == 'DD/MM/YYYY LT') {
                            var lower = this['selectedAlarmsLowerbound'].split(" ");
                            request['aqDatetimeLowerbound'] = moment(lower[0], 'DD/MM/YYYY').add(offset, 'minutes').format('YYYY-MM-DD') + 'T' + moment(lower[1], 'HH:mm').add(offset, 'minutes').format('HH:mm:ss') + 'Z';
                        } else {
                            request['aqDatetimeLowerbound'] = moment(this['selectedAlarmsLowerbound'], 'DD/MM/YYYY').add(offset, 'minutes').format('YYYY-MM-DD') + 'T23:59:59';
                        }
                    }
                    
                    if(this.fields.upperboundAttributes != undefined && this['selectedAlarmsUpperbound'] != undefined) {
                        if(this.fields.upperboundAttributes.dateFormat.value == 'DD/MM/YYYY LT') {
                            var upper = this['selectedAlarmsUpperbound'].split(" ");
                            request['aqDatetimeUpperbound'] = moment(upper[0], 'DD/MM/YYYY').add(offset, 'minutes').format('YYYY-MM-DD') + 'T' + moment(upper[1], 'HH:mm').add(offset, 'minutes').format('HH:mm:ss') + 'Z';
                        } else {
                            request['aqDatetimeUpperbound'] = moment(this['selectedAlarmsUpperbound'], 'DD/MM/YYYY').add(1, 'day').format('YYYY-MM-DD') + 'T01:00:00Z';
                        }
                    }
                }

                return request;
            },

            getClientAlarms() {
                if(!this.ready)
                    this.overlay(true);

                this.$store
                .dispatch('getClientAlarms', this.generateDevicesQueries())
                .catch(error => {
                    if(!this.ready)
                        this.overlay(false);

                    this.notify(this.$options.filters.notification({endpoint: 'GetClientAlarms', code: error}));            

                    this.rows = [];

                    if(!this.ready)
                        this.ready = true;
                })
                .then(({data}) => {
                    if(!this.ready)
                        this.overlay(false);

                    this.notify(this.$options.filters.notification({endpoint: 'GetClientAlarms', code: 200}));

                    if(data != undefined && data.alarms != undefined) {
                        this.rows = data.alarms;
                    } else {
                        this.rows = [];
                    }

                    this.$scrollTo('#alarms-datatable', {offset: -20});
                    
                    if(!this.ready)
                        this.ready = true;
                });          
            },
            
            getAlarmLog() {
                if(!this.ready)
                    this.overlay(true);

                this.$store
                .dispatch('getAlarmLog', this.generateDevicesQueries())
                .catch(error => {
                    if(!this.ready)
                        this.overlay(false);

                    this.notify(this.$options.filters.notification({endpoint: 'GetAlarmLog', code: error}));            

                    this.rows = [];

                    if(!this.ready)
                        this.ready = true;
                })
                .then(({data}) => {
                    if(!this.ready)
                        this.overlay(false);

                    this.notify(this.$options.filters.notification({endpoint: 'GetAlarmLog', code: 200}));

                    if(data != undefined && data.alarms != undefined) {
                        this.rows = data.alarms;
                    } else {
                        this.rows = [];
                    }

                    this.$scrollTo('#alarms-datatable', {offset: -20});
                    
                    if(!this.ready)
                        this.ready = true;
                });          
            },

            overlay(action) {
                this.loading = action;
            }, 
        }
    }
</script>
